import { render, staticRenderFns } from "./colorPickerQr.vue?vue&type=template&id=281e9ee3&scoped=true&"
import script from "./colorPickerQr.vue?vue&type=script&lang=js&"
export * from "./colorPickerQr.vue?vue&type=script&lang=js&"
import style0 from "./colorPickerQr.vue?vue&type=style&index=0&id=281e9ee3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281e9ee3",
  null
  
)

export default component.exports